import { captureException } from '@tandemone/observability/browser'

/** wraps captureException with the unknown-to-Error narrowing every
 * mutation onError handler ends up doing. swallows the type juggling
 * so call sites stay short: reportError(err).
 */
export function reportError(err: unknown): void {
  captureException(err instanceof Error ? err : new Error(String(err)))
}
